import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const enderecoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    tipoEndereco: Yup.string().notRequired(),
    cep: Yup.string()
      .matches(/^\d{2}\.\d{3}-\d{3}$/, t('validation.cep'))
      .required(v.requiredField('cep')),
    logradouro: Yup.string()
      .min(5, v.minField(5))
      .max(50, v.maxField(50))
      .required(v.requiredField('logradouro')),
    numero: Yup.string().required(v.requiredField('numero')),
    complemento: Yup.string().notRequired(),
    bairro: Yup.string()
      .min(3, v.minField(5))
      .max(50, v.maxField(50))
      .required(v.requiredField('bairro')),
    cidade: Yup.string()
      .min(3, v.minField(5))
      .max(50, v.maxField(50))
      .required(v.requiredField('cidade')),
    uf: Yup.object().nullable().required(v.requiredField('estado', 'select')),
  })
}
